import {debounce as _debounce, map as _map} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {Field} from 'redux-form';

import {gql, withApollo} from 'react-apollo';
import {showConstraintsModal} from '@modules/events/utils/constraintsTables';
import {eventPresets} from '@graphql/propertyLicences/eventPresets';
import {FiltersWrapper, getSelectedValues} from '@appComponents/HOCFiltersWrapper';
import Form from '@appComponents/ReduxFormControls';
import {convertToInt} from '@utils/helpers';
import {sortDropdownOptionsAlphanumerically} from '@utils/sorters';
import {
    EVENT_NON_SPORTRADAR_TYPE,
    EVENT_SPORTRADAR_TYPE,
    EVENT_STAGE_TYPE,
} from '@constants/variables';
import {contentCategoriesFilteredByLevelAndParents} from '@graphql/content';
import {tournamentCategoriesFilteredBySports} from '@graphql/tournamentCategories';
import {GetStadiumsByTournamentsForDropdown} from '@graphql/stadium/query';
import {GetTournamentsByTournamentCategories} from '@graphql/tournament/query';
import {GetStageCategories} from '@graphql/stageCategory/query';
import {GetSportsForDropdown} from '@graphql/sport/query';
import {GetContentCategoriesForDropdown} from '@graphql/contentCategory/query';
import {GetTvChannelsForDropdown} from '@graphql/tvChannels/query';
import {filteredSelectedTournament, filteredSelectedTournamentCategory} from '@modules/events/utils/eventSchedule';
import {getTodayDate, getEndOfTodayDate} from '@utils/date';
import {defineNextState} from '@utils/filters';
import {DateRangeFilter} from '@utils/commonFilters/DateRangeFilter';
import {ContentTypesFilter} from '@utils/commonFilters/ContentTypesFilter';
import {ContentVariantsFilter} from '@utils/commonFilters/ContentVariantsFilter';
import {EventStatusFilter} from '@utils/commonFilters/EventStatusFilter';
import {EventTypeFilter} from '@utils/commonFilters/EventTypeFilter';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {PropertyLicencesFilter} from '@utils/commonFilters/PropertyLicencesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {ContentCategoriesLevel1Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel1Filter';
import {ContentCategoriesLevel2Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel2Filter';
import {ContentCategoriesLevel3Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel3Filter';
import {SportsFilter} from '@utils/commonFilters/SportsFilter';
import {TournamentsFilter} from '@utils/commonFilters/TournamentsFilter';
import {TournamentCategoriesFilter} from '@utils/commonFilters/TournamentCategoriesFilter';

import {setTvChannelState} from '../utils/eventContentHelper';

export class EventScheduleFiltersComponent extends React.Component {
    static propTypes = {
        client: PropTypes.object.isRequired,
        clipProviders: PropTypes.array,
        contentCategoriesLevel1: PropTypes.array,
        contributionTypes: PropTypes.array,
        data: PropTypes.object.isRequired,
        encodingDatacenters: PropTypes.array,
        eventStatuses: PropTypes.array,
        eventTypes: PropTypes.array,
        eventContentTypes: PropTypes.array,
        eventContentVariants: PropTypes.array,
        filters: PropTypes.object.isRequired,
        form: PropTypes.object.isRequired,
        report: PropTypes.array,
        matchScheduleStates: PropTypes.array,
        hasMatchId: PropTypes.array,
        hasStageId: PropTypes.array,
        loading: PropTypes.bool.isRequired,
        matchProperties: PropTypes.array,
        MessageBox: PropTypes.object,
        products: PropTypes.array,
        productStatuses: PropTypes.array,
        propertyLicences: PropTypes.array,
        scheduledOrNot: PropTypes.array,
        sports: PropTypes.array,
        tvChannels: PropTypes.array,
        restoreFilterValues: PropTypes.func.isRequired,
        restoreFilterDateValues: PropTypes.func.isRequired,
        venues: PropTypes.array,
    };

    static defaultProps = {
        clipProviders: [],
        contentCategoriesLevel1: [],
        contributionTypes: [],
        encodingDatacenters: [],
        eventStatuses: [],
        eventTypes: [],
        report: [],
        matchScheduleStates: [],
        hasMatchId: [],
        hasStageId: [],
        matchProperties: [],
        products: [],
        productStatuses: [],
        propertyLicences: [],
        scheduledOrNot: [],
        sports: [],
        venues: [],
        tvChannels: [],
        eventContentTypes: [],
        eventContentVariants: [],
    };

    static onSubmit = (data) => {
        let from = moment(data.from).format('YYYY-MM-DD HH:mm'),
            to = moment(data.to).format('YYYY-MM-DD HH:mm');

        if (from !== data.from && to !== data.to) {
            data.from = getTodayDate();
            data.to = getEndOfTodayDate();
        } else if (from !== data.from) {
            data.from = moment(data.to).subtract(1, 'd').format('YYYY-MM-DD HH:mm');
        }  else if (to !== data.to) {
            data.to = moment(data.from).add(1, 'd').format('YYYY-MM-DD HH:mm');
        }

        showConstraintsModal(data);

        return data;
    };

    constructor() {
        super();

        this.state = {
            clipProviders: [],
            contentCategoriesLevel2: [],
            contentCategoriesLevel3: [],
            eventPresets: [],
            fromMaxDate: null,
            fromMaxDateDefault: null,
            fromMaxTime: moment().hours(23).minutes(59),
            hasContentCategoryLevel1: false,
            hasContentCategoryLevel2: false,
            hasSport: false,
            hasTournamentCategory: false,
            hasSelectedContentCategoryLevel1: false,
            hasSelectedContentCategoryLevel2: false,
            hasSelectedCoverage: false,
            hasSelectedPropertyLicence: false,
            hasSelectedSport: false,
            hasSelectedTournament: false,
            hasSelectedTournamentCategory: false,
            selectedContentCategoriesLevel2: [],
            selectedContentCategoriesLevel3: [],
            selectedEventPresets: [],
            selectedStadiums: [],
            selectedTournamentCategories: [],
            selectedTournaments: [],
            stadiums: [],
            toMinDate: null,
            toMinDateDefault: null,
            toMinTime: moment().hours(0).minutes(0),
            tournamentCategories: [],
            tournaments: [],
            tvChannels: [],
            tvChannelsLoading: false,
            sports: [],
            sportsLoading: false,
            contentCategoriesLevel1: [],
            contentCategoriesLevel1Loading: false,
            isSportradar: false,
            isStage: false,
            hasSelectedFirstStageCategory: false,
            firstStageCategories: [],
            secondStageCategories: [],
            firstStageCategoriesLoading: false,
            secondStageCategoriesLoading: false,
            selectedFirstStageCategories: null,
            selectedSecondStageCategories: null,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.hasSelectedSport && this.state.selectedTournamentCategories
            && this.state.hasSelectedSport !== prevState.hasSelectedSport) {
            this.setState(() => ({
                selectedTournamentCategories: [],
            }));
        }

        if (!this.state.hasSelectedTournamentCategory && this.state.selectedTournaments
            && this.state.hasSelectedTournamentCategory !== prevState.hasSelectedTournamentCategory) {
            this.setState(() => ({
                selectedTournaments: [],
            }));
        }

        if (!this.state.hasSelectedContentCategoryLevel1 && this.state.selectedContentCategoriesLevel2
            && this.state.hasSelectedContentCategoryLevel1 !== prevState.hasSelectedContentCategoryLevel1) {
            this.setState(() => ({
                selectedContentCategoriesLevel2: [],
            }));
        }

        filteredSelectedTournamentCategory(this.state.selectedSports, prevState, this.setState.bind(this));
        filteredSelectedTournament(
            prevState,
            this.setState.bind(this),
            this.state.tournaments,
            this.state.selectedTournaments
        );
    }

    getEventPresetsFromGraphQL = _debounce((propertyLicenceIds) => {
        this.props.client.query({
            query: gql(eventPresets),
            variables: {propertyLicence: propertyLicenceIds},
        }).then((result) => {
            let eventPresets = result.data.eventPresets.mapDataForDropdownWithIntVal().sort((a, b) => (
                    a.text > b.text ? 1 : -1
                )),
                selectedEventPresets = this.state.selectedEventPresets;

            this.setState(() => ({
                eventPresets: eventPresets,
                eventPresetsLoading: false,
            }));

            this.props.form.changeValue('eventPreset', getSelectedValues(selectedEventPresets, eventPresets));
        }).catch((error) => {
            this.setState(() => ({
                eventPresets: [],
                eventPresetsLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch event presets filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getSportsFromGraphQL = _debounce((isStage = false) => {
        this.props.client.query({
            query: GetSportsForDropdown,
            ...(isStage ? {variables: {isStage}} : {}),
        }).then((result) => {
            this.setState(() => ({
                sportsLoading: false,
                sports: sortDropdownOptionsAlphanumerically(result.data.sports.map((sport) => ({
                    key: sport.value,
                    text: sport.text,
                    value: convertToInt(sport.value),
                }))),
            }));
        }).catch((error) => {
            this.setState(() => ({
                sport: [],
                sportsLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch sports filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getContentCategoriesFromGraphQL = _debounce(() => {
        this.props.client.query({
            query: GetContentCategoriesForDropdown,
            variables: {
                level: 1,
            },
        }).then((result) => {
            this.setState(() => ({
                contentCategoriesLevel1Loading: false,
                contentCategoriesLevel1: sortDropdownOptionsAlphanumerically(
                    result.data.contentCategories.map((contentCategory) => ({
                        key: contentCategory.value,
                        text: contentCategory.text,
                        value: convertToInt(contentCategory.value),
                    }))),
            }));
        }).catch((error) => {
            this.setState(() => ({
                contentCategoriesLevel1: [],
                contentCategoriesLevel1Loading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch contentCategoriesLevel1 filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getTvChannelsFromGraphQL = _debounce(() => {
        this.props.client.query({
            query: GetTvChannelsForDropdown,
        }).then((result) => {
            this.setState(() => ({
                tvChannels: result.data.tvChannels.mapDataForDropdownWithIntVal(),
            }));
        }).catch((error) => {
            this.setState(() => ({
                contentCategoriesLevel1: [],
                contentCategoriesLevel1Loading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch tvChannels filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getTournamentCategoriesFromGraphQL = _debounce((sportIds) => {
        this.props.client.query({
            query: gql(tournamentCategoriesFilteredBySports),
            variables: {
                sports: sportIds,
            },
        }).then((result) => {
            const tournamentCategories = sortDropdownOptionsAlphanumerically(
                    result.data.tournamentCategories.mapDataForDropdownWithIntVal()
                ),
                selectedTournamentCategories = this.state.selectedTournamentCategories;

            this.setState(() => ({
                selectedSports: sportIds,
                tournamentCategories: tournamentCategories,
                tournamentCategoriesLoading: false,
            }));

            this.props.form.changeValue('tournamentCategories',
                getSelectedValues(selectedTournamentCategories, tournamentCategories)
            );
        }).catch((error) => {
            this.setState(() => ({
                tournamentCategories: [],
                tournamentCategoriesLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch tournament categories filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getTournamentsFromGraphQL = _debounce((tournamentCategoryIds) => {
        this.props.client.query({
            query: GetTournamentsByTournamentCategories,
            variables: {
                tournamentCategories: tournamentCategoryIds,
            },
        }).then((result) => {
            const tournaments = sortDropdownOptionsAlphanumerically(
                    result.data.tournaments.mapDataForDropdownWithIntVal()
                ),
                selectedTournaments = this.state.selectedTournaments;

            this.setState(() => ({
                tournaments: tournaments,
                tournamentsLoading: false,
            }));

            this.props.form.changeValue('tournaments',
                getSelectedValues(selectedTournaments, tournaments)
            );
        }).catch((error) => {
            this.setState(() => ({
                tournaments: [],
                tournamentsLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch tournaments filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getStadiumsFromGraphQL = _debounce((tournamentIds) => {
        this.props.client.query({
            query: GetStadiumsByTournamentsForDropdown,
            variables: {tournaments: tournamentIds},
        }).then((result) => {
            let stadiums = result.data.stadiums.mapDataForDropdownWithIntVal(),
                selectedStadiums = this.state.selectedStadiums;

            this.setState(() => ({
                stadiums: stadiums,
                stadiumsLoading: false,
            }));

            this.props.form.changeValue('stadium', getSelectedValues(selectedStadiums, stadiums));
        }).catch((error) => {
            this.setState(() => ({
                stadiums: [],
                stadiumsLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch stadiums filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getContentCategoriesLevel2FromGraphQL = _debounce((contentCategoryLevel1Ids) => {
        this.props.client.query({
            query: gql(contentCategoriesFilteredByLevelAndParents),
            variables: {
                level: 2,
                parents: contentCategoryLevel1Ids,
            },
        }).then((result) => {
            const contentCategoriesLevel2 = sortDropdownOptionsAlphanumerically(
                    result.data.contentCategories.mapDataForDropdownWithIntVal()
                ),
                selectedContentCategoriesLevel2 = this.state.selectedContentCategoriesLevel2;

            this.setState(() => ({
                contentCategoriesLevel2: contentCategoriesLevel2,
                contentCategoriesLevel2Loading: false,
            }));

            this.props.form.changeValue('contentCategoriesLevel2',
                getSelectedValues(selectedContentCategoriesLevel2, contentCategoriesLevel2)
            );
        }).catch((error) => {
            this.setState(() => ({
                contentCategoriesLevel2: [],
                contentCategoriesLevel2Loading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch 2nd level content categories filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getContentCategoriesLevel3FromGraphQL = _debounce((contentCategoryLevel2Ids) => {
        this.props.client.query({
            query: gql(contentCategoriesFilteredByLevelAndParents),
            variables: {
                level: 3,
                parents: contentCategoryLevel2Ids,
            },
        }).then((result) => {
            const contentCategoriesLevel3 = sortDropdownOptionsAlphanumerically(
                    result.data.contentCategories.mapDataForDropdownWithIntVal()
                ),
                selectedContentCategoriesLevel3 = this.state.selectedContentCategoriesLevel3;

            this.setState(() => ({
                contentCategoriesLevel3: contentCategoriesLevel3,
                contentCategoriesLevel3Loading: false,
            }));

            this.props.form.changeValue('contentCategoriesLevel3',
                getSelectedValues(selectedContentCategoriesLevel3, contentCategoriesLevel3)
            );
        }).catch((error) => {
            this.setState(() => ({
                contentCategoriesLevel3: [],
                contentCategoriesLevel3Loading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch 3rd level content categories filter data',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getFirstStageCategoriesFromGraphQL = _debounce((sportIds) => {
        this.props.client.query({
            query: GetStageCategories,
            variables: {
                sport: sportIds,
            },
        }).then((result) => {
            const firstStageCategories = result.data.stageCategories.map((category) => ({
                key: category.id,
                text: category.name,
                value: convertToInt(category.id),
            }));

            this.setState(() => ({
                firstStageCategories: firstStageCategories,
                firstStageCategoriesLoading: false,
            }));

            const currentSelected = this.state.selectedFirstStageCategories || [];

            this.props.form.changeValue(
                'firstStageCategories',
                getSelectedValues(currentSelected, firstStageCategories)
            );
        }).catch((error) => {
            this.setState(() => ({
                firstStageCategories: [],
                firstStageCategoriesLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch first stage categories',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    getSecondStageCategoriesFromGraphQL = _debounce((firstStageCategoryIds) => {
        this.props.client.query({
            query: GetStageCategories,
            variables: {
                parent: firstStageCategoryIds,
            },
        }).then((result) => {
            const secondStageCategories = result.data.stageCategories.map((category) => ({
                key: category.id,
                text: category.name,
                value: convertToInt(category.id),
            }));

            const currentSelected = this.state.selectedSecondStageCategories || [];

            this.setState(() => ({
                secondStageCategories: secondStageCategories,
                secondStageCategoriesLoading: false,
            }));

            this.props.form.changeValue(
                'secondStageCategories',
                getSelectedValues(currentSelected, secondStageCategories)
            );
        }).catch((error) => {
            this.setState(() => ({
                secondStageCategories: [],
                secondStageCategoriesLoading: false,
            }));

            this.props.MessageBox.addMessage(
                'eventsIndex',
                'Failed to fetch second stage categories',
                `${error}`,
                'error'
            );
        });
    }, 1000);

    onPropertyLicenceChange = (event, value) => {
        let state = {
            hasSelectedPropertyLicence: false,
            eventPresets: [],
            eventPresetsLoading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedPropertyLicence: true,
                eventPresetsLoading: true,
            };

            let propertyLicenceIds = value.map(propertyLicence => convertToInt(propertyLicence));

            this.getEventPresetsFromGraphQL(propertyLicenceIds);
        } else {
            this.props.form.changeValue('eventPreset', null);
        }

        this.setState(() => (state));
    };

    onEventPresetChange = (event, value) => {
        this.setState(() => ({selectedEventPresets: value}));
    };

    onEventTypeChange = (event, value) => {
        const type = convertToInt(value),
            isSportradar = type === EVENT_SPORTRADAR_TYPE,
            isStage = type === EVENT_STAGE_TYPE,
            hasContentCategoryLevel1 = type === EVENT_NON_SPORTRADAR_TYPE,
            hasSport = isSportradar || isStage;

        const fieldsToReset = [
            'sports',
            'tournamentCategories',
            'tournaments',
            'stadium',
            'firstStageCategories',
            'secondStageCategories',
        ];

        if (hasContentCategoryLevel1) {
            fieldsToReset.push(
                'contentCategoriesLevel1',
                'contentCategoriesLevel2',
                'contentCategoriesLevel3',
                'venue'
            );
        }

        fieldsToReset.forEach(field => this.props.form.changeValue(field, null));

        if (hasContentCategoryLevel1) {
            this.getContentCategoriesFromGraphQL();
        } else if (hasSport) {
            this.getSportsFromGraphQL(isStage);
        }

        this.setState(() => ({
            hasSelectedContentCategoryLevel1: false,
            hasSelectedSport: false,
            hasContentCategoryLevel1,
            contentCategoriesLevel1Loading: true,
            hasSport,
            isSportradar,
            isStage,
            sportsLoading: hasSport,
            hasSelectedFirstStageCategory: false,
        }));
    };

    onSportChange = (event, value) => {
        let state = {
            hasSelectedSport: false,
            hasSportsWithTvChannel: false,
            tournamentCategories: [],
            tournamentCategoriesLoading: false,
            tvChannelsLoading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedSport: true,
                tournamentCategoriesLoading: true,
                selectedSportValues: value,
                firstStageCategoriesLoading: true,
            };

            const sportIds = _map(value, (sport) => (convertToInt(sport)));

            setTvChannelState(this.props.form, value, this.setStateHandler, 'eventsIndex');

            this.getTvChannelsFromGraphQL();
            this.getTournamentCategoriesFromGraphQL(sportIds);
            this.getFirstStageCategoriesFromGraphQL(sportIds);
        } else {
            state = {
                hasSelectedSport: false,
                hasSportsWithTvChannel: false,
                tournamentCategories: [],
                tournamentCategoriesLoading: false,
                tvChannelsLoading: false,
                selectedSportValues: [],
                hasSelectedFirstStageCategory: false,
                firstStageCategories: [],
                firstStageCategoriesLoading: false,
                secondStageCategories: [],
                secondStageCategoriesLoading: false,
                selectedSecondStageCategories: null,
                selectedFirstStageCategories: null,
            };

            this.props.form.changeValue('tournamentCategories', null);
            this.props.form.changeValue('firstStageCategories', null);
            this.props.form.changeValue('secondStageCategories', null);
            this.props.form.changeValue('tvChannels', null);
        }

        this.setState(() => (state));
    };

    setStateHandler = (stateObject) => {
        this.setState(() => (stateObject));
    };

    onFirstStageCategoryChange = (event, value) => {
        const hasSelected = value && 0 < value.length;

        if (!hasSelected) {
            this.props.form.changeValue('secondStageCategories', null);

            this.setState(() => ({
                hasSelectedFirstStageCategory: false,
                selectedFirstStageCategories: null,
                selectedSecondStageCategories: null,
                secondStageCategories: [],
                secondStageCategoriesLoading: false,
            }));
        } else {
            const firstStageCategoryIds = value.map(id => convertToInt(id));

            this.setState(() => ({
                hasSelectedFirstStageCategory: true,
                selectedFirstStageCategories: value,
                secondStageCategoriesLoading: true,
                secondStageCategories: null,
            }));

            this.getSecondStageCategoriesFromGraphQL(firstStageCategoryIds);
        }
    };

    onSecondStageCategoryChange = (event, value) => {
        this.setState(() => ({
            selectedSecondStageCategories: value,
        }));
    };

    onTournamentCategoryChange = (event, value) => {
        let state = {
            hasSelectedTournamentCategory: false,
            tournaments: [],
            tournamentsLoading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedTournamentCategory: true,
                selectedTournamentCategories: value,
                tournamentsLoading: true,
            };

            let tournamentCategoryIds = _map(value, (tournamentCategory) => (
                parseInt(tournamentCategory, 10)
            ));

            this.getTournamentsFromGraphQL(tournamentCategoryIds);
        } else {
            this.props.form.changeValue('tournaments', null);
        }

        this.setState(() => (state));
    };

    onTournamentChange = (event, value) => {
        let state = {
            hasSelectedTournament: false,
            stadiums: [],
            stadiumsLoading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedTournament: true,
                selectedTournaments: value,
                stadiumsLoading: true,
            };

            let tournamentIds = value.map(tournament => convertToInt(tournament));

            this.getStadiumsFromGraphQL(tournamentIds);
        } else {
            this.props.form.changeValue('stadium', null);
        }

        this.setState(() => (state));
    };

    onStadiumChange = (event, value) => {
        this.setState(() => ({selectedStadiums: value}));
    };

    onContentCategoryLevel1Change = (event, value) => {
        let state = {
            hasSelectedContentCategoryLevel1: false,
            contentCategoriesLevel2: [],
            contentCategoriesLevel2Loading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedContentCategoryLevel1: true,
                contentCategoriesLevel2Loading: true,
            };

            let contentCategoryLevel2Ids = _map(value, (contentCategoryLevel2) => (
                parseInt(contentCategoryLevel2, 10)
            ));

            this.getContentCategoriesLevel2FromGraphQL(contentCategoryLevel2Ids);
        } else {
            this.props.form.changeValue('contentCategoriesLevel2', null);
        }

        this.setState(() => (state));
    };

    onContentCategoryLevel2Change = (event, value) => {
        let state = {
            hasSelectedContentCategoryLevel2: false,
            contentCategoriesLevel3: [],
            contentCategoriesLevel3Loading: false,
        };

        if (0 < value.length) {
            state = {
                hasSelectedContentCategoryLevel2: true,
                selectedContentCategoriesLevel2: value,
                contentCategoriesLevel3Loading: true,
            };

            let contentCategoryLevel3Ids = _map(value, (contentCategoryLevel3) => (
                parseInt(contentCategoryLevel3, 10)
            ));

            this.getContentCategoriesLevel3FromGraphQL(contentCategoryLevel3Ids);
        } else {
            this.props.form.changeValue('contentCategoriesLevel3', null);
        }

        this.setState(() => (state));
    };

    onContentCategoryLevel3Change = (event, value) => {
        this.setState(() => ({
            selectedContentCategoriesLevel3: value,
        }));
    };

    onChange = (date, name) => {
        let nextState = {};

        defineNextState(nextState, this.state, date, name);

        this.setState(() => (nextState));
    };

    onCoverageChange = (event, value) => {
        if (0 < value.length) {
            this.setState({
                hasSelectedCoverage: true,
                selectedCoverage: value,
            });
        } else {
            this.setState({ hasSelectedCoverage: false });
            this.props.form.changeValue('clipProviders', []);
        }
    };

    render() {
        const {
                clipProviders,
                contributionTypes,
                coverage,
                encodingDatacenters,
                eventContentTypes,
                eventContentVariants,
                eventStatuses,
                eventTypes,
                report,
                matchScheduleStates,
                hasMatchId,
                hasStageId,
                matchProperties,
                products,
                productStatuses,
                propertyLicences,
                scheduledOrNot,
                venues,
            } = this.props.data,
            loading = this.props.loading;

        return (
            <div className='eventSchedule__filters filter__controls__container'>
                <SearchFilter
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <DateRangeFilter
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterDateValues={this.props.restoreFilterDateValues}
                    onChange={this.onChange}
                    dateConfig={{
                        fromMaxDate: this.state.fromMaxDate,
                        fromMaxDateDefault: this.state.fromMaxDateDefault,
                        fromMaxTime: this.state.fromMaxTime,
                        toMinDate: this.state.toMinDate,
                        toMinDateDefault: this.state.toMinDateDefault,
                        toMinTime: this.state.toMinTime,
                    }}
                />
                <PropertyLicencesFilter
                    propertyLicences={propertyLicences}
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    onChangeValue={this.onPropertyLicenceChange}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={this.state.eventPresetsLoading || loading}
                    hidden={!this.state.hasSelectedPropertyLicence}
                    loading={this.state.eventPresetsLoading || loading}
                    multiple
                    name='eventPreset'
                    onChangeValue={this.onEventPresetChange}
                    options={this.state.eventPresets}
                    placeholder='Applied preset'
                    search
                    selection
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'eventPreset')}
                />
                <EventTypeFilter
                    eventTypes={eventTypes}
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    onChangeValue={this.onEventTypeChange}
                />
                <SportsFilter
                    sports={this.state.sports}
                    loading={this.state.sportsLoading || loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    hidden={!this.state.hasSport}
                    onChangeValue={this.onSportChange}
                />
                <TournamentCategoriesFilter
                    tournamentCategories={this.state.tournamentCategories}
                    loading={this.state.tournamentCategoriesLoading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    hidden={!this.state.hasSelectedSport || !this.state.isSportradar}
                    onChangeValue={this.onTournamentCategoryChange}
                />
                <TournamentsFilter
                    tournaments={this.state.tournaments}
                    loading={this.state.tournamentsLoading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    hidden={!this.state.hasSelectedTournamentCategory}
                    onChangeValue={this.onTournamentChange}
                    disabled={this.state.tournamentsLoading || this.state.tournamentCategoriesLoading}
                />
                <Field
                    className='--customWidth --stadium'
                    component={Form.ReduxSelect}
                    disabled={
                        this.state.stadiumsLoading
                        || this.state.tournamentsLoading
                        || this.state.tournamentCategoriesLoading
                    }
                    hidden={!this.state.hasSelectedTournament}
                    loading={this.state.stadiumsLoading}
                    multiple
                    name='stadium'
                    onChangeValue={this.onStadiumChange}
                    options={this.state.stadiums}
                    placeholder='Venue / Court'
                    search
                    selection
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'stadium')}
                />
                <ContentCategoriesLevel1Filter
                    loading={this.state.contentCategoriesLevel1Loading || loading}
                    hidden={!this.state.hasContentCategoryLevel1}
                    options={this.state.contentCategoriesLevel1}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    onChangeValue={this.onContentCategoryLevel1Change}
                />
                <ContentCategoriesLevel2Filter
                    loading={this.state.contentCategoriesLevel2Loading}
                    hidden={!this.state.hasSelectedContentCategoryLevel1}
                    options={this.state.contentCategoriesLevel2}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    onChangeValue={this.onContentCategoryLevel2Change}
                />
                <ContentCategoriesLevel3Filter
                    loading={this.state.contentCategoriesLevel3Loading || this.state.contentCategoriesLevel2Loading}
                    hidden={!this.state.hasSelectedContentCategoryLevel2}
                    options={this.state.contentCategoriesLevel3}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                    onChangeValue={this.onContentCategoryLevel3Change}
                />
                <Field
                    className='--customWidth --venue'
                    component={Form.ReduxSelect}
                    disabled={this.state.contentCategoriesLevel1Loading || loading}
                    hidden={!this.state.hasContentCategoryLevel1}
                    loading={this.state.contentCategoriesLevel1Loading || loading}
                    multiple
                    name='venue'
                    options={venues}
                    placeholder='Venue'
                    search
                    selection
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'venue')}
                />
                <Field
                    component={Form.ReduxSelect}
                    name='tvChannels'
                    hidden={!this.state.hasSportsWithTvChannel || !this.state.isSportradar}
                    options={this.state.tvChannels}
                    disabled={this.state.tvChannelsLoading || loading}
                    placeholder='TV channel'
                    loading={this.state.tvChannelsLoading || loading}
                    multiple
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'tvChannels')}
                    selection
                    search
                />
                <Field
                    component={Form.ReduxSelect}
                    name='firstStageCategories'
                    placeholder='1st stage category'
                    disabled={this.state.firstStageCategoriesLoading || loading}
                    loading={this.state.firstStageCategoriesLoading}
                    hidden={!this.state.isStage || !this.state.hasSelectedSport}
                    options={this.state.firstStageCategories}
                    onChangeValue={this.onFirstStageCategoryChange}
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'firstStageCategories')}
                    multiple
                    selection
                    search
                />
                <Field
                    component={Form.ReduxSelect}
                    name='secondStageCategories'
                    placeholder='2nd stage category'
                    disabled={this.state.secondStageCategoriesLoading || this.state.firstStageCategoriesLoading || loading}
                    loading={this.state.secondStageCategoriesLoading}
                    hidden={!this.state.hasSelectedFirstStageCategory}
                    options={this.state.secondStageCategories}
                    onChangeValue={this.onSecondStageCategoryChange}
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'secondStageCategories')}
                    multiple
                    selection
                    search
                />
                <br className='clearfix'/>
                <Field
                    className='--minimalWidth --scheduledOrNot'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    name='scheduled'
                    options={scheduledOrNot}
                    placeholder='Scheduled or not'
                    selection
                    setValue={
                        null !== this.props.restoreFilterValues(this.props.filters.EventSchedule, 'scheduled')
                            ? this.props.restoreFilterValues(this.props.filters.EventSchedule, 'scheduled') ? 1 : 0
                            : null
                    }
                />
                <Field
                    className='--minimalWidth --hasMatchId'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    name='hasMatchId'
                    options={hasMatchId}
                    placeholder='Has match ID?'
                    selection
                    setValue={
                        null !== this.props.restoreFilterValues(this.props.filters.EventSchedule, 'hasMatchId')
                            ? this.props.restoreFilterValues(this.props.filters.EventSchedule, 'hasMatchId') ? 1 : 0
                            : null
                    }
                />
                <Field
                    className='--minimalWidth'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    name='hasStageId'
                    options={hasStageId}
                    placeholder='Has stage ID?'
                    selection
                    setValue={
                        null !== this.props.restoreFilterValues(this.props.filters.EventSchedule, 'hasStageId')
                            ? this.props.restoreFilterValues(this.props.filters.EventSchedule, 'hasStageId') ? 1 : 0
                            : null
                    }
                />
                <EventStatusFilter
                    eventStatuses={eventStatuses}
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <Field
                    className='--customWidth --products'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='coverage'
                    options={sortDropdownOptionsAlphanumerically(coverage)}
                    placeholder='Coverage'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'coverage')}
                    onChangeValue={this.onCoverageChange}
                />
                {this.state.hasSelectedCoverage &&
                    (
                        <Field
                            className='--customWidth --clipProviders'
                            component={Form.ReduxSelect}
                            disabled={loading}
                            loading={loading}
                            multiple
                            name='clipProviders'
                            options={sortDropdownOptionsAlphanumerically(clipProviders)}
                            placeholder='Clip providers'
                            search
                            setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'clipProviders')}
                        />
                    )
                }
                <ContentTypesFilter
                    eventContentTypes={eventContentTypes}
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <ContentVariantsFilter
                    eventContentVariants={eventContentVariants}
                    loading={loading}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='contributionType'
                    options={contributionTypes}
                    placeholder='Contribution type'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'contributionType')}
                />
                <Field
                    className='--customWidth --encodingDatacenter'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='encodingDatacenter'
                    options={encodingDatacenters}
                    placeholder='Datacenter'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'encodingDatacenter')}
                />
                <ProductsFilter
                    loading={loading}
                    products={products}
                    filters={this.props.filters.EventSchedule}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <Field
                    className='--customWidth --productStatus'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='productStatus'
                    options={productStatuses}
                    placeholder='Product status'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'productStatus')}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='matchProperties'
                    options={matchProperties}
                    placeholder='Match properties'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'matchProperties')}
                />
                <Field
                    className='--customWidth'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='matchScheduleStates'
                    options={matchScheduleStates}
                    placeholder='SR schedule state'
                    selection
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'matchScheduleStates')}
                />
                <Field
                    className='--customWidth --report'
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    name='report'
                    options={report}
                    placeholder='Report'
                    selection
                    multiple
                    setValue={this.props.restoreFilterValues(this.props.filters.EventSchedule, 'report')}
                />
            </div>
        );
    }
}

const EventScheduleFilters = FiltersWrapper(withApollo(EventScheduleFiltersComponent), {
    name: 'EventSchedule',
    onSubmit: EventScheduleFiltersComponent.onSubmit,
    initialValues: {
        from: getTodayDate(),
        to: getEndOfTodayDate(),
    },
});

export default EventScheduleFilters;
